import { useLocation, useNavigate } from "react-router-dom";

interface NavUtils {
  scrollToTop: () => void;
  goBack: () => void;
  timeMachine: () => void;
  home: () => void;
  favorites: () => void;
  show: (identifier: string, term?: string) => void;
  search: (term?: string, year?: string) => void;
  year: (year: string) => void;
  chords: (identifier: string) => void;
  chordsList: () => void;
  radio: () => void;
  mobilePlayer: () => void;
}

export const useNavUtils = (): NavUtils => {
  const navigate = useNavigate();
  const location = useLocation();

  const utils: NavUtils = {
    scrollToTop: () => {
      setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }));
    },
    goBack: () => {
      navigate(-1);
    },
    timeMachine: () => {
      utils.scrollToTop();
      navigate(`/timemachine`);
    },
    home: () => {
      utils.scrollToTop();
      navigate(`/`);
    },
    favorites: () => {
      utils.scrollToTop();
      navigate(`/favorites`);
    },
    show: (identifier, term) => {
      utils.scrollToTop();
      navigate(`/show/${identifier}`, {
        state: {
          term,
        },
      });
    },
    search: (term, year) => {
      if (!term) {
        return;
      }
      utils.scrollToTop();
      navigate(`/search/${year ? `${year}/` : ""}${term}`, {
        replace: location.pathname.startsWith("/search"),
      });
    },
    year: (year) => {
      utils.scrollToTop();
      navigate(`/year/${year}`);
    },
    chords: (identifier) => {
      utils.scrollToTop();
      navigate(`/chords/${identifier}`);
    },
    chordsList: () => {
      utils.scrollToTop();
      navigate(`/chords`);
    },
    radio: () => {
      utils.scrollToTop();
      navigate(`/radio`);
    },
    mobilePlayer: () => {
      utils.scrollToTop();
      navigate(`/player`);
    },
  };

  return utils;
};
